import { Injectable, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { IDisbursementSession } from '../interfaces/disbursement-session';
import { IValidationResult } from '../interfaces/validation-result';
import { FundingAccountOperation } from '../enums/funding-account-operation';
import { Validation } from '../enums/validation';
import { IFundingAccountToken } from '../interfaces/funding-account-token';
import { EventEmitterService } from "../services/event-emitter.service";
import { environment } from '../../environments/environment';
import { DisbursementSessionService }  from "../services/disbursement-session.service";
import { NONE_TYPE } from '@angular/compiler';

declare let aci: any;
let listener: any;

@Injectable({
  providedIn: 'root'
})

export class SdkService {

  public FundingAccountTokenObtained: EventEmitter<string> = new EventEmitter<string>();

  protected sdkHostUrl = environment.sdkHostUrl;
  protected sdkVersion = environment.sdkVersion;
  // protected billerId = environment.billerId;

  private envRegion: string = '';
  private sessionId: string = '';
  private paymentMethod: string = '';
  private handler: any;
  private operationStatus = new BehaviorSubject<FundingAccountOperation>(FundingAccountOperation.None);
  private onValidate = new BehaviorSubject<IValidationResult | null>(null);

  private form = new FormGroup({});

  // get onValidate$(): Observable<IValidationResult | null> { return this.onValidate.asObservable(); }

  private temporalExecution : boolean = false;
  submitting = new BehaviorSubject(false);

  constructor(
    private router: Router,
    private eventEmitterService: EventEmitterService,
    private disbursementSessionService: DisbursementSessionService,
  ) { }

  setForm(form: FormGroup): void {
    this.form = form;
  }

  public loadJsSdkScript(billerId: string): void {
    // console.log('SdkService: ', 'loadJsSdkScript()');

    const script = document.createElement('script');
    script.setAttribute('data-aci-speedpay', '');
    script.src = `${this.sdkHostUrl}/js-sdk/${this.sdkVersion}/speedpay.js?billerId=${billerId}`;
    script.referrerPolicy = 'strict-origin';
    script.crossOrigin = 'anonymous';
    // console.log('Sdk source: ', script.src);

    const head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(script);
  }

  public initGateway(envRegion: string, disbursementSession: IDisbursementSession, paymentMethod: string, form: FormGroup): void {

  //  console.log('initGateway', 'inside');
  //  console.log('envRegion', envRegion);
  //  console.log('apiAuthKey', disbursementSession.apiAuthKey);
  //  console.log('accessToken', disbursementSession.accessToken);
  //  console.log('billerAccountId', disbursementSession.billerAccountId);
  //  console.log('paymentMethod', paymentMethod);
    this.envRegion = envRegion;
    this.sessionId = disbursementSession.sessionId;
    this.form = form;
    this.paymentMethod = paymentMethod;

      // this.callbackUrl = billerDetails.callbackUrl;

      listener = this.listen.bind(this);
      window.addEventListener('message', listener);

      this.handler = aci.speedpay.fundingAccountGateway.init(
        {
          apiAuthKey: disbursementSession.apiAuthKey,
          accessToken: disbursementSession.accessToken,
          billerAccountId: disbursementSession.billerAccountId,
          paymentMethod: paymentMethod,
          styles: {
            iframe: {
              height: '3.2em'
            },
            input: {
              color: 'black',
              padding: '0 0 0 1em',
              lineheight: '2.7em',
              fontfamily: 'Verdana,sans-serif',
              background: 'white',
              border: 'none', //c2d5eb inset 4px',
              //  borderradius: '6px',
              width: {
                "card-number": '20em'
              },
              onfocus: {
                border: 'none'
              },
              valid: {
                background: '#e8f0fe',
                border: 'none', // '#c2d5eb inset 4px',
                borderradius: '6px',
                "card-number": {
                  background: 'red',
                }
              },
              // padding: '2em 2em 2em 2em',
              invalid: {
                border: 'none', //'#c2d5eb inset 4px',
                background: 'lightyellow',
                borderradius: '6px'
              }
            },
            placeholder: {
              content: {
              "expiration-date": "MM YY"
              }
            }
           }
        }
      );

      this.operationStatus.next(FundingAccountOperation.Init);

    // }
    const fail = (error : any) => {
      // console.log('error');
      // console.log(error);
    }

    // this.dataService.sdkToken(this.auth.billerAccountId)
      // .pipe(first())
      // .subscribe(success, fail);
  }

  private listen( {data} : MessageEvent): void {
    // console.log('js-sdk-event: ', data);

    if (this.paymentMethod == 'ACH') {
      this.eventEmitterService.onAchElementValueChanged();
    } else if (this.paymentMethod == 'Card') {
      this.eventEmitterService.onCardElementValueChanged();
    }     

    // Some kind of a failed validation
    if (data.validationResult) {
      this.onValidation(data.validationResult);
    }
    // Token created successfully
    else if (data.fundingAccountSucessResult) {
      this.onSuccess(data.fundingAccountSucessResult);
    }

    else if (data.fundingAccountFailureResult) {
      // console.log('js-sdk-event: ', 'fundingAccountFailureResult');
      // console.log('data.fundingAccountFailureResult: ', data.fundingAccountFailureResult);
      let { message, kind } = data.fundingAccountFailureResult;
      let validationMessage = message.default;
      // console.log('validationMessage',  validationMessage);
      // console.log('kind',  kind);
      if (this.paymentMethod == 'ACH') {
        this.eventEmitterService.onAchFundingAccountException(validationMessage);
      } else if (this.paymentMethod == 'Card') {
        this.eventEmitterService.onCardFundingAccountException(validationMessage);
      } 
      // this.eventEmitterService.onServiceComponentEvent('Incorrect funding account provided.');
      // window.alert('Incorrect funding accountprovided');
    }

    else if (data.authenticationResult) {
      console.log('js-sdk-event: ', JSON.stringify(data));
    }

    else if (!data) {
    }

    // else {
    //   window.alert('System error');
    // }
  }

  private onValidation(validationResult: IValidationResult): void {
    let { details, kind } = validationResult;
    // console.log('details',details);
    // console.log('kind',kind);

    this.onValidate.next(validationResult)

//    if (details.length > 1 && kind === Validation.Error) {
    if (details.length > 1) {
      details.forEach(detail => {

          // console.log('detail.kind', detail.kind);
          // console.log('detail', detail);

          if (detail.kind !== Validation.Valid) {

          // } else if (detail.kind ===  Validation.InvalidFieldValue) {
            let targetField = detail.target;
            let validationMessage = detail.message.default;
            if (this.paymentMethod == 'Card') {
              switch(targetField) {
                case 'card-number':
                  // targetField = 'iframe-card-number';
                  this.eventEmitterService.onCardFundingAccountException('Card number: ' + validationMessage);
                  break;
                case 'expiration-date':
                  // targetField = 'iframe-expiration-date';
                  this.eventEmitterService.onCardFundingAccountException('Expiration date: ' + validationMessage);
                  break;
                case 'security-code':
                  // targetField = 'iframe-security-code';
                  this.eventEmitterService.onCardFundingAccountException('Security code: ' + validationMessage);
              }
            }
            const control = this.form.get(targetField) as FormControl;
            // debugger;
            if (control) {
              // console.log('onValidation', targetField + ' : ' + validationMessage);
              // control.patchValue('');
              control.markAsDirty();
              control.setErrors({ 'incorrect': true});
            } else {
              console.log('onValidation: no targetField', validationMessage);
            }

          }
        }
      )
    }
  }

  createToken(temporaryExecution : boolean): void {
    // console.log('createToken', 'inside');
    this.updateListener(temporaryExecution);
    this.handler.createToken();
    this.submitting.next(true);
    this.operationStatus.next(FundingAccountOperation.Creating);
  }

  updateListener(temporaryExecution :boolean){
    // console.log('updateListener', 'inside');
    this.temporalExecution = temporaryExecution;
    if (listener) {
      window.removeEventListener('message', listener);
      listener = this.listen.bind(this);
      window.addEventListener('message', listener);
    }
  }

  private onSuccess(result: IFundingAccountToken ): void {
    // console.log('onSuccess', result);
    // let callbackUrl = this.callbackUrl
    //   .replace('{tokenSaved}',  (!result.token.singleUse).toString())
    //   .replace('{tokenId}', result.token.id);
    // console.log('onSuccess', callbackUrl);
    if (this.paymentMethod == 'ACH') {
      this.eventEmitterService.onAchFundingAccountException('');
    } else if (this.paymentMethod == 'Card') {
      this.eventEmitterService.onCardFundingAccountException('');
    } 
    let tokenId = result.token.id;
    this.FundingAccountTokenObtained.emit(tokenId);
    this.disbursementSessionService.postTokenId(this.envRegion, this.sessionId, result.paymentMethod, tokenId)
    .subscribe({
      next: (response) => {
        if (response) {
          this.router.navigate(['/dsb-funding-accounts']);
        }
      },
      error: (error) => {
        console.log('error', error);
        if (this.paymentMethod == 'ACH') {
          this.eventEmitterService.onAchFundingAccountException(error);
        } else if (this.paymentMethod == 'Card') {
          this.eventEmitterService.onCardFundingAccountException(error);
        } 
      },
      complete: () => {
      }
    });
  }

  public onCancel(): void {
    // console.log('Redirect to cancel');
    // let callbackUrl = this.callbackUrl.replace('{tokenId}', '0');
    this.FundingAccountTokenObtained.emit();
    this.disbursementSessionService.postTokenId(this.envRegion, this.sessionId, '', '0')
    .subscribe({
      next: (response) => {
      },
      error: (error) => {
      },
      complete: () => {
      }
    });
  }
}
